import { ImageWithLoader } from '@/components/ui/image-with-loader';
import { cn } from '@/lib/utils';

import { Asset } from '../../../types';
import { getAssetUrl } from '../../../utils/asset-loader';

interface AssetThumbnailGridProps {
  assets: Asset[];
  assetsBaseUrl: string;
}

export const AssetThumbnailGrid = ({ assets, assetsBaseUrl }: AssetThumbnailGridProps) => {
  return (
    <div className={cn('grid h-full grid-cols-2 items-center gap-1 overflow-hidden p-1')}>
      {assets.slice(0, 4).map((asset, idx) => {
        const isLastThumbnail = idx === 3;
        const hasMoreAssets = assets.length > 4;
        const remainingCount = assets.length - 4;

        return (
          <div
            key={asset.id}
            className="relative flex aspect-square items-center justify-center overflow-hidden rounded bg-livelinx-grey100"
          >
            <div className="flex h-full w-full items-center justify-center p-1">
              <ImageWithLoader
                src={getAssetUrl(asset, assetsBaseUrl)}
                alt={asset.title}
                className="max-h-full max-w-full object-contain"
                containerClassName="w-full h-full flex items-center justify-center"
                skeletonClassName="w-full h-full"
                loading="lazy"
              />
            </div>

            {isLastThumbnail && hasMoreAssets && (
              <div className="absolute inset-0 flex items-center justify-center bg-black/60">
                <span className="text-xl font-bold text-white sm:text-2xl">+{remainingCount}</span>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};
